<template>
    <section class="bg-white">
        <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6 ">
            <div class="mx-auto max-w-screen-sm text-center mb-8 lg:mb-16">
                <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 ">Categorias</h2>
                <p class="font-light text-gray-500 lg:mb-16 sm:text-xl dark:text-gray-400">Explore nossa vasta linha de
                    películas por categoria</p>
            </div>
            <div class="grid gap-8 mb-6 lg:mb-16 md:grid-cols-2">
                <div class="items-center bg-gray-50 rounded-lg shadow sm:flex">
                    <router-link to="/peliculas-profissionais" class="w-[300px]">
                        <img class="w-full rounded-lg sm:rounded-none sm:rounded-l-lg"
                            src="@/assets/images/categorias/imagem-cat-pelicula-automotiva.webp"
                            alt="Películas Profissionais">
                    </router-link>
                    <div class="p-5">
                        <h3 class="text-xl font-bold tracking-tight text-gray-900 ">
                            <a href="#">Películas Profissionais</a>
                        </h3>
                        <p class="mt-3 mb-4 font-light text-gray-500 ">Proteção solar e privacidade para seu carro.</p>
                        <router-link to="/peliculas-profissionais">
                            <button type="button" class="inline-flex items-center text-blue-700 hover:underline cursor-pointer">
                                Acesse
                                <svg class="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
                                </svg>
                            </button>
                        </router-link>
                    </div>
                </div>
                <div class="items-center bg-gray-50 rounded-lg shadow sm:flex">
                    <router-link to="/peliculas-nanoceramica" class="w-[300px]">
                        <img class="w-full rounded-lg sm:rounded-none sm:rounded-l-lg"
                            src="@/assets/images/categorias/imagem-sala-pelicula-nanoceramica.webp"
                            alt="Películas de Nano Cerâmica">
                    </router-link>
                    <div class="p-5">
                        <h3 class="text-xl font-bold tracking-tight text-gray-900 ">
                            <a href="#">Películas de Nano Cerâmica</a>
                        </h3>
                        <p class="mt-3 mb-4 font-light text-gray-500 ">Menos calor, mais conforto, sem escurecer.</p>
                        <router-link to="/peliculas-nanoceramica">
                            <button type="button" class="inline-flex items-center text-blue-700 hover:underline cursor-pointer">
                                Acesse
                                <svg class="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
                                </svg>
                            </button>
                        </router-link>
                    </div>
                </div>
                 <div class="items-center bg-gray-50 rounded-lg shadow sm:flex">
                    <router-link to="/peliculas-de-seguranca" class="w-[300px]">
                        <img class="w-full rounded-lg sm:rounded-none sm:rounded-l-lg"
                            src="@/assets/images/categorias/imagem-martelo-pelicula-seguranca.webp"
                            alt="Películas de Segurança">
                    </router-link>
                    <div class="p-5">
                        <h3 class="text-xl font-bold tracking-tight text-gray-900 ">
                            <a href="#">Películas de Segurança</a>
                        </h3>
                        <p class="mt-3 mb-4 font-light text-gray-500 ">Reforço contra impactos e invasões.</p>
                        <router-link to="/peliculas-de-seguranca">
                            <button type="button" class="inline-flex items-center text-blue-700 hover:underline cursor-pointer">
                                Acesse
                                <svg class="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
                                </svg>
                            </button>
                        </router-link>


                    </div>
                </div>
                
                <div class="items-center bg-gray-50 rounded-lg shadow sm:flex">
                    <router-link to="/peliculas-arquitetura-e-decorativa" class="w-[300px]">
                        <img class="w-full rounded-lg sm:rounded-none sm:rounded-l-lg"
                            src="@/assets/images/categorias/imagem-escritorio-pelicula-decor.webp"
                            alt="Películas Decorativas e Arquitetônicas">
                    </router-link>
                    <div class="p-5">
                        <h3 class="text-xl font-bold tracking-tight text-gray-900 ">
                            <a href="#">Arquitetônicas e Decorativas</a>
                        </h3>
                        <p class="mt-3 mb-4 font-light text-gray-500 ">Estilo, privacidade e conforto.</p>
                        <router-link to="/peliculas-arquitetura-e-decorativa">
                            <button type="button" class="inline-flex items-center text-blue-700 hover:underline cursor-pointer">
                                Acesse
                                <svg class="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
                                </svg>
                            </button>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'CategorySection'

}
</script>

<style></style>